<!--
 * @Description: 更换银行卡
-->
<template>
  <scroll-layout>
    <template #header>
      <div class="header-wrap">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>银行卡管理</el-breadcrumb-item>
          <el-breadcrumb-item>添加银行卡</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="button-wrap">
          <ykc-button type="plain" @click="handleBack">返回</ykc-button>
        </div>
      </div>
    </template>

    <div class="bank-card-edit">
      <el-steps :active="activeStep" align-center finish-status="success" class="bank-card-steps">
        <el-step title="填写银行卡信息" />
        <el-step title="账号核对" />
        <el-step title="绑定成功" />
      </el-steps>

      <!-- 步骤1：填写银行卡信息 -->
      <div v-if="activeStep === 0" class="bank-card-form-wrap">
        <ykc-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="140px"
          class="bank-card-form">
          <ykc-form-item label="账户类型：" prop="accountType">
            <ykc-radio
              :data="accountTypeOptions"
              @change="handleAccountTypeChange"
              v-model="ruleForm.accountType"></ykc-radio>
          </ykc-form-item>

          <ykc-form-item
            v-if="ruleForm.accountType === ACCOUNT_TYPE_COMPANY"
            label="开户银行行号："
            prop="openNo">
            <ykc-input
              placeholder="请输入开户银行行号"
              maxlength="50"
              v-model="ruleForm.openNo"></ykc-input>
          </ykc-form-item>

          <ykc-form-item label="银行名称：" prop="bankName">
            <ykc-input
              placeholder="请输入银行名称"
              maxlength="50"
              v-model="ruleForm.bankName"></ykc-input>
          </ykc-form-item>

          <ykc-form-item :label="bankNoLabel" prop="bankNo">
            <ykc-input
              :placeholder="bankNoPlaceholder"
              maxlength="50"
              v-model="ruleForm.bankNo"></ykc-input>
          </ykc-form-item>

          <ykc-form-item :label="holderLabel" prop="holder">
            <ykc-input
              :placeholder="holderPlaceholder"
              maxlength="50"
              v-model="ruleForm.holder"></ykc-input>
          </ykc-form-item>

          <ykc-form-item label="银行预留手机号：" prop="mobile">
            <ykc-input
              placeholder="请输入该银行账户在银行的预留手机号"
              maxlength="11"
              v-model="ruleForm.mobile"></ykc-input>
          </ykc-form-item>
        </ykc-form>

        <div class="form-footer">
          <ykc-button
            type="primary"
            :disabled="!isFormValid"
            :loading="submitting"
            @click="handleNext">
            确认变更
          </ykc-button>
        </div>
      </div>

      <!-- 步骤2：账号核对 -->
      <div v-if="activeStep === 1" class="bank-card-confirm-wrap">
        <div class="confirm-card">
          <div class="confirm-card-header">
            <span class="bank-name">{{ ruleForm.bankName || '银行卡信息' }}</span>
            <span class="back-edit" @click="handleBackEdit">返回修改</span>
          </div>
          <div class="confirm-card-body">
            <div class="confirm-item">
              <span class="label">银行账号类型</span>
              <span class="value">{{ accountTypeText }}</span>
            </div>
            <div v-if="ruleForm.accountType === ACCOUNT_TYPE_COMPANY" class="confirm-item">
              <span class="label">开户银行行号</span>
              <span class="value">{{ ruleForm.openNo || '-' }}</span>
            </div>
            <div class="confirm-item">
              <span class="label">银行名称</span>
              <span class="value">{{ ruleForm.bankName || '-' }}</span>
            </div>
            <div class="confirm-item">
              <span class="label">银行账号</span>
              <span class="value">{{ ruleForm.bankNo | formatCardNo }}</span>
            </div>
            <div class="confirm-item">
              <span class="label">{{ holderLabel }}</span>
              <span class="value">{{ ruleForm.holder || '-' }}</span>
            </div>
            <div class="confirm-item">
              <span class="label">银行预留手机号</span>
              <span class="value">{{ ruleForm.mobile || '-' }}</span>
            </div>
          </div>
        </div>
        <div class="form-footer">
          <ykc-button type="primary" :loading="submitting" @click="handleConfirm">确认</ykc-button>
        </div>
      </div>

      <!-- 步骤3：绑定成功 -->
      <div v-if="activeStep === 2" class="bank-card-success-wrap">
        <div class="success-icon">
          <i class="el-icon-check"></i>
        </div>
        <div class="success-title">绑定成功</div>
        <div class="success-tip">该银行卡将用于后续的资金提现</div>
        <ykc-button type="primary" @click="handleKnow">知道了</ykc-button>
      </div>
    </div>
  </scroll-layout>
</template>

<script>
  import regexpObj from '@/utils/regexp';
  import { merchantAccountCenter } from '@/service/apis';

  const ACCOUNT_TYPE_COMPANY = 1;
  const ACCOUNT_TYPE_PRIVATE = 2;

  export default {
    name: 'BankCardEdit',
    data() {
      return {
        ACCOUNT_TYPE_COMPANY,
        ACCOUNT_TYPE_PRIVATE,
        activeStep: 0,
        submitting: false,
        operatorId: null,
        accountTypeOptions: [
          { id: ACCOUNT_TYPE_COMPANY, name: '企业对公户' },
          { id: ACCOUNT_TYPE_PRIVATE, name: '法人对私卡' },
        ],
        ruleForm: {
          accountType: ACCOUNT_TYPE_COMPANY,
          openNo: '',
          bankName: '',
          bankNo: '',
          holder: '',
          mobile: '',
        },
        rules: {
          accountType: [{ required: true, message: '请选择账户类型', trigger: 'change' }],
          openNo: [
            {
              validator: (rule, value, callback) => {
                if (this.ruleForm.accountType === ACCOUNT_TYPE_COMPANY && !value) {
                  callback(new Error('请输入开户银行行号'));
                } else {
                  callback();
                }
              },
              trigger: 'blur',
            },
          ],
          bankName: [{ required: true, message: '请输入银行名称', trigger: 'blur' }],
          bankNo: [{ required: true, message: '请输入银行账号', trigger: 'blur' }],
          holder: [{ required: true, message: '请输入账户名称', trigger: 'blur' }],
          mobile: [
            { required: true, message: '请输入银行预留手机号', trigger: 'blur' },
            {
              trigger: 'blur',
              pattern: regexpObj.regexp.input.cellphoneType.regexp,
              message: regexpObj.regexp.input.cellphoneType.errorTips.error('银行预留手机号'),
            },
          ],
        },
      };
    },
    computed: {
      bankNoLabel() {
        return this.ruleForm.accountType === ACCOUNT_TYPE_COMPANY ? '企业银行账号：' : '银行卡号：';
      },
      bankNoPlaceholder() {
        return this.ruleForm.accountType === ACCOUNT_TYPE_COMPANY
          ? '请输入账户下企业银行账号'
          : '请输入账户下的银行卡号';
      },
      holderLabel() {
        return this.ruleForm.accountType === ACCOUNT_TYPE_COMPANY ? '银行账户名：' : '法人姓名：';
      },
      holderPlaceholder() {
        return this.ruleForm.accountType === ACCOUNT_TYPE_COMPANY
          ? '请输入银行账户名'
          : '请输入姓名';
      },
      accountTypeText() {
        const item = this.accountTypeOptions.find(
          option => option.id === this.ruleForm.accountType
        );
        return item ? item.name : '-';
      },
      isFormValid() {
        const { accountType, openNo, bankName, bankNo, holder, mobile } = this.ruleForm;
        if (!accountType || !bankName || !bankNo || !holder || !mobile) {
          return false;
        }
        if (accountType === ACCOUNT_TYPE_COMPANY && !openNo) {
          return false;
        }
        return regexpObj.regexp.input.cellphoneType.regexp.test(mobile);
      },
    },
    filters: {
      formatCardNo(val) {
        if (!val) return '-';
        return String(val).replace(/(\d{4})(?=\d)/g, '$1 ');
      },
    },
    created() {
      this.operatorId = Number(this.$route.query.operatorId) || null;
    },
    methods: {
      /** 账户类型切换 */
      handleAccountTypeChange() {
        this.ruleForm.openNo = '';
        this.$refs.ruleForm.clearValidate();
      },
      /** 下一步：账号核对 */
      handleNext() {
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            this.activeStep = 1;
          }
        });
      },
      /** 返回修改 */
      handleBackEdit() {
        this.activeStep = 0;
      },
      /** 确认变更 */
      handleConfirm() {
        const params = {
          operatorId: this.operatorId,
          accountType: this.ruleForm.accountType,
          openNo: this.ruleForm.openNo,
          bankName: this.ruleForm.bankName,
          bankNo: this.ruleForm.bankNo,
          holder: this.ruleForm.holder,
          mobile: this.ruleForm.mobile,
        };
        this.submitting = true;
        merchantAccountCenter
          .editBankCard(params)
          .then(() => {
            this.activeStep = 2;
          })
          .finally(() => {
            this.submitting = false;
          });
      },
      /** 返回商户账户中心 */
      handleBack() {
        this.$router.push({
          path: '/merchantAccountCenter/merchantAccountCenter',
        });
      },
      /** 知道了：返回商户账户中心 */
      handleKnow() {
        this.$router.push({
          path: '/merchantAccountCenter/merchantAccountCenter',
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .header-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .button-wrap {
      margin-right: 20px;
    }
  }

  .bank-card-edit {
    padding: 20px;
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    min-height: 600px;

    .bank-card-steps {
      width: 600px;
      margin: 20px auto 40px;
    }

    .bank-card-form-wrap {
      width: 640px;
      margin: 0 auto;

      .bank-card-form {
        .ykc-radio {
          margin-top: 8px;
        }
      }

      .form-footer {
        display: flex;
        justify-content: center;
        margin-top: 40px;

        .ykc-button {
          min-width: 160px;
        }
      }
    }

    .bank-card-confirm-wrap {
      width: 640px;
      margin: 0 auto;

      .confirm-card {
        border: 1px solid #ebeef5;
        border-radius: 4px;
        overflow: hidden;

        .confirm-card-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 16px 24px;
          background: #f5f7fa;

          .bank-name {
            font-size: 18px;
            font-weight: 600;
            color: #303133;
          }

          .back-edit {
            font-size: 14px;
            color: #1890ff;
            cursor: pointer;

            &:hover {
              color: #40a9ff;
            }
          }
        }

        .confirm-card-body {
          padding: 24px;

          .confirm-item {
            display: flex;
            margin-bottom: 16px;
            font-size: 14px;
            line-height: 22px;

            &:last-child {
              margin-bottom: 0;
            }

            .label {
              width: 120px;
              color: #909399;
              flex-shrink: 0;
            }

            .value {
              flex: 1;
              color: #303133;
              word-break: break-all;
            }
          }
        }
      }

      .form-footer {
        display: flex;
        justify-content: center;
        margin-top: 40px;

        .ykc-button {
          min-width: 160px;
        }
      }
    }

    .bank-card-success-wrap {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding-top: 80px;

      .success-icon {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        background: #1890ff;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;

        i {
          font-size: 48px;
          color: #fff;
          font-weight: bold;
        }
      }

      .success-title {
        font-size: 24px;
        font-weight: 600;
        color: #1890ff;
        margin-bottom: 12px;
      }

      .success-tip {
        font-size: 14px;
        color: #606266;
        margin-bottom: 32px;
      }

      .ykc-button {
        min-width: 120px;
      }
    }
  }
</style>
